
export default {
    props: {
        mode: String
    }
}
